import React from "react";

class DropdownCAE extends React.Component {
  render() {
    return (
      <React.Fragment>
        <option></option>
        <option value="01111">01111 - Cerealicultura (excepto arroz)</option>
        <option value="01112">
          01112 - Cultura de leguminosas secas e sementes oleaginosas
        </option>
        <option value="01120">01120 - Cultura de arroz</option>
        <option value="01130">01130 - Culturas de produtos hortícolas</option>
        <option value="01140">01140 - Cultura de cana-de-açúcar</option>
        <option value="01150">01150 - Cultura de tabaco</option>
        <option value="01160">01160 - Cultura de plantas têxteis</option>
        <option value="01191">
          01191 - Cultura de flores e de plantas ornamentais
        </option>
        <option value="01192">01192 - Outras culturas temporárias</option>
        <option value="01210">01210 - Viticultura</option>
        <option value="01220">
          01220 - Cultura de frutos tropicais e subtropicais
        </option>
        <option value="01230">01230 - Cultura de citrinos</option>
        <option value="01240">01240 - Cultura de pomóideas e prunóideas</option>
        <option value="01251">01251 - Cultura de frutos de casca rija</option>
        <option value="01252">
          01252 - Cultura de outros frutos em árvores e arbustos
        </option>
        <option value="01261">01261 - Olivicultura</option>
        <option value="01262">
          01262 - Cultura de outros frutos oleaginosos
        </option>
        <option value="01270">
          01270 - Cultura de plantas destinadas à preparação de bebidas
        </option>
        <option value="01280">01280 - Cultura de especiarias</option>
        <option value="01290">01290 - Outras culturas permanentes</option>
        <option value="01300">
          01300 - Cultura de materiais de propagação vegetativa
        </option>
        <option value="01410">
          01410 - Criação de bovinos para produção de leite
        </option>
        <option value="01420">
          01420 - Criação de outros bovinos (excepto para produção de leite) e
          búfalos
        </option>
        <option value="01430">01430 - Criação de equinos</option>
        <option value="01440">01440 - Criação de camelos e camelídeos</option>
        <option value="01450">01450 - Criação de ovinos e caprinos</option>
        <option value="01460">01460 - Suinicultura</option>
        <option value="01470">01470 - Avicultura</option>
        <option value="01491">01491 - Apicultura</option>
        <option value="01492">01492 - Cunicultura</option>
        <option value="01493">01493 - Criação de animais de companhia</option>
        <option value="01494">01494 - Outra produção animal</option>
        <option value="01500">
          01500 - Agricultura e produção animal combinadas
        </option>
        <option value="01610">
          01610 - Actividades dos serviços relacionados com a agricultura
        </option>
        <option value="01620">
          01620 - Actividades dos serviços relacionados com a produção animal
        </option>
        <option value="01630">
          01630 - Preparação de produtos agrícolas para venda{" "}
        </option>
        <option value="01640">
          01640 - Preparação e tratamento de sementes para propagação
        </option>
        <option value="01701">01701 - Caça e repovoamento cinegético</option>
        <option value="01702">
          01702 - Actividades dos serviços relacionados com a caça e
          repovoamento cinegético
        </option>
        <option value="02100">
          02100 - Silvicultura e outras actividades florestais
        </option>
        <option value="02200">02200 - Exploração florestal</option>
        <option value="02300">02300 - Extracção de cortiça</option>
        <option value="02400">
          02400 - Actividades dos serviços relacionados com a silvicultura e
          exploração florestal
        </option>
        <option value="03111">03111 - Pesca marítima </option>
        <option value="03112">
          03112 - Apanha de algas e de outros produtos do mar
        </option>
        <option value="03121">03121 - Pesca em águas interiores</option>
        <option value="03122">
          03122 - Apanha de produtos de águas interiores
        </option>
        <option value="03210">
          03210 - Aquicultura em águas salgadas e salobras
        </option>
        <option value="03220">03220 - Aquicultura em águas doces</option>
        <option value="05100">
          05100 - Extracção de hulha (inclui antracite)
        </option>
        <option value="05200">05200 - Extracção de lenhite</option>
        <option value="06100">06100 - Extracção de petróleo bruto</option>
        <option value="06200">06200 - Extracção de gás natural</option>
        <option value="07100">
          07100 - Extracção e preparação de minérios de ferro
        </option>
        <option value="07210">
          07210 - Extracção e preparação de minérios de urânio e de tório
        </option>
        <option value="07290">
          07290 - Extracção e preparação de outros minérios metálicos não
          ferrosos
        </option>
        <option value="08111">
          08111 - Extracção de mármore e outras rochas carbonatadas
        </option>
        <option value="08112">
          08112 - Extracção de granito ornamental e rochas similares
        </option>
        <option value="08113">08113 - Extracção de calcário e cré</option>
        <option value="08114">08114 - Extracção de gesso </option>
        <option value="08115">08115 - Extracção de ardósia</option>
        <option value="08121">08121 - Extracção de saibro</option>
        <option value="08122">08122 - Extracção de argilas e caulino</option>
        <option value="08910">
          08910 - Extracção de minerais para a indústria química e para a
          fabricação de adubos
        </option>
        <option value="08920">08920 - Extracção da turfa</option>
        <option value="08931">08931 - Extracção de sal marinho</option>
        <option value="08932">08932 - Extracção de sal gema</option>
        <option value="08991">08991 - Extracção de feldspato</option>
        <option value="08992">
          08992 - Extracção de outros minerais não metálicos
        </option>
        <option value="09100">
          09100 - Actividades dos serviços relacionados com a extracção de
          petróleo e gás
        </option>
        <option value="09900">
          09900 - Outras actividades dos serviços relacionados com as indústrias
          extractivas
        </option>
        <option value="10110">10110 - Abate de gado (produção de carne)</option>
        <option value="10120">10120 - Abate de aves (produção de carne)</option>
        <option value="10130">
          10130 - Fabricação de produtos à base de carne
        </option>
        <option value="10201">
          10201 - Preparação de produtos da pesca e da aquicultura
        </option>
        <option value="10202">
          10202 - Congelação de produtos da pesca e da aquicultura
        </option>
        <option value="10203">
          10203 - Conservação de produtos da pesca e da aquicultura em azeite e
          outros óleos vegetais e outros molhos
        </option>
        <option value="10204">10204 - Salga</option>
        <option value="10310">
          10310 - Preparação e conservação de batatas
        </option>
        <option value="10320">
          10320 - Fabricação de sumos de frutos e de produtos hortícolas
        </option>
        <option value="10391">
          10391 - Congelação de frutos e de produtos hortícolas
        </option>
        <option value="10392">
          10392 - Secagem e desidratação de frutos e de produtos hortícolas
        </option>
        <option value="10393">10393 - Fabricação de doces</option>
        <option value="10394">
          10394 - Descasque e transformação de frutos de casca rija comestíveis
        </option>
        <option value="10395">
          10395 - Preparação e conservação de frutos e de produtos hortícolas
          por outros processos
        </option>
        <option value="10411">
          10411 - Produção de óleos e gorduras animais brutos{" "}
        </option>
        <option value="10412">10412 - Produção de azeite</option>
        <option value="10413">
          10413 - Produção de óleos vegetais brutos (excepto azeite){" "}
        </option>
        <option value="10414">10414 - Refinação de azeite</option>
        <option value="10420">
          10420 - Fabricação de margarinas e de gorduras alimentares similares
        </option>
        <option value="10510">10510 - Indústrias do leite e derivados</option>
        <option value="10520">10520 - Fabricação de gelados e sorvetes</option>
        <option value="10611">10611 - Moagem de cereais</option>
        <option value="10612">10612 - Descasque</option>
        <option value="10613">
          10613 - Transformação de cereais e leguminosas
        </option>
        <option value="10620">10620 - Fabricação de amidos</option>
        <option value="10711">10711 - Panificação </option>
        <option value="10712">10712 - Pastelaria</option>
        <option value="10720">10720 - Fabricação de bolachas</option>
        <option value="10730">10730 - Fabricação de massas alimentícias</option>
        <option value="10810">10810 - Indústria do açúcar</option>
        <option value="10821">
          10821 - Fabricação de cacau e de chocolate{" "}
        </option>
        <option value="10822">
          10822 - Fabricação de produtos de confeitaria
        </option>
        <option value="10830">10830 - Indústria do café e do chá</option>
        <option value="10840">
          10840 - Fabricação de condimentos e temperos
        </option>
        <option value="10850">
          10850 - Fabricação de refeições e pratos pré-cozinhados
        </option>
        <option value="10860">
          10860 - Fabricação de alimentos homogeneizados e dietéticos
        </option>
        <option value="10891">10891 - Fabricação de fermentos</option>
        <option value="10892">10892 - Fabricação de caldos</option>
        <option value="10893">
          10893 - Fabricação de outros produtos alimentares diversos
        </option>
        <option value="10911">10911 - Fabricação de pré-misturas</option>
        <option value="10912">
          10912 - Fabricação de alimentos para animais de criação (excepto para
          aquicultura)
        </option>
        <option value="10913">
          10913 - Fabricação de alimentos para aquicultura
        </option>
        <option value="10920">
          10920 - Fabricação de alimentos para animais de companhia
        </option>
        <option value="11011">
          11011 - Fabricação de aguardentes preparadas
        </option>
        <option value="11012">
          11012 - Fabricação de aguardentes não preparadas
        </option>
        <option value="11013">
          11013 - Produção de licores e de outras bebidas destiladas
        </option>
        <option value="11021">
          11021 - Produção de vinhos comuns e licorosos{" "}
        </option>
        <option value="11022">
          11022 - Produção de vinhos espumantes e espumosos
        </option>
        <option value="11030">
          11030 - Fabricação de cidra e outras bebidas fermentadas de frutos
        </option>
        <option value="11040">
          11040 - Fabricação de vermutes e de outras bebidas fermentadas não
          destiladas
        </option>
        <option value="11050">11050 - Fabricação de cerveja</option>
        <option value="11060">11060 - Fabricação de malte</option>
        <option value="11071">
          11071 - Engarrafamento de águas minerais naturais e de nascente
        </option>
        <option value="11072">
          11072 - Fabricação de refrigerantes e de outras bebidas não alcoólicas
        </option>
        <option value="12000">12000 - Preparação de tabaco</option>
        <option value="13101">
          13101 - Preparação e fiação de fibras do tipo algodão
        </option>
        <option value="13102">
          13102 - Preparação e fiação de fibras do tipo lã
        </option>
        <option value="13103">
          13103 - Preparação e fiação da seda e preparação e texturização de
          filamentos sintéticos e artificiais
        </option>
        <option value="13104">13104 - Fabricação de linhas de costura</option>
        <option value="13105">
          13105 - Preparação e fiação de linho e de outras fibras têxteis
        </option>
        <option value="13201">13201 - Tecelagem de fio do tipo algodão</option>
        <option value="13202">13202 - Tecelagem de fio do tipo lã</option>
        <option value="13203">
          13203 - Tecelagem de fio do tipo seda e de outros têxteis
        </option>
        <option value="13301">13301 - Branqueamento e tingimento</option>
        <option value="13302">13302 - Estampagem </option>
        <option value="13303">13303 - Acabamento de fios</option>
        <option value="13910">13910 - Fabricação de tecidos de malha</option>
        <option value="13920">
          13920 - Fabricação de artigos têxteis confeccionados
        </option>
        <option value="13930">13930 - Fabricação de tapetes e carpetes</option>
        <option value="13941">13941 - Fabricação de cordoaria </option>
        <option value="13942">13942 - Fabricação de redes </option>
        <option value="13950">
          13950 - Fabricação de não tecidos e respectivos artigos
        </option>
        <option value="13961">
          13961 - Fabricação de passamanarias e sirgarias
        </option>
        <option value="13962">
          13962 - Fabricação de têxteis para uso técnico e industrial
        </option>
        <option value="13991">13991 - Fabricação de bordados </option>
        <option value="13992">13992 - Fabricação de rendas</option>
        <option value="13993">
          13993 - Fabricação de outros têxteis diversos
        </option>
        <option value="14110">14110 - Confecção de vestuário em couro</option>
        <option value="14120">
          14120 - Confecção de vestuário de trabalho
        </option>
        <option value="14131">
          14131 - Confecção de outro vestuário exterior em série
        </option>
        <option value="14132">
          14132 - Confecção de outro vestuário exterior por medida
        </option>
        <option value="14133">
          14133 - Actividades de acabamento de artigos de vestuário
        </option>
        <option value="14140">14140 - Confecção de vestuário interior</option>
        <option value="14190">
          14190 - Confecção de outros artigos e acessórios de vestuário
        </option>
        <option value="14200">
          14200 - Fabricação de artigos de peles com pêlo
        </option>
        <option value="14310">
          14310 - Fabricação de meias e similares de malha
        </option>
        <option value="14390">
          14390 - Fabricação de outro vestuário de malha
        </option>
        <option value="15111">
          15111 - Curtimenta e acabamento de peles sem pêlo
        </option>
        <option value="15112">15112 - Fabricação de couro reconstituído</option>
        <option value="15113">
          15113 - Curtimenta e acabamento de peles com pêlo
        </option>
        <option value="15120">
          15120 - Fabricação de artigos de viagem e de uso pessoal
        </option>
        <option value="15201">15201 - Fabricação de calçado</option>
        <option value="15202">
          15202 - Fabricação de componentes para calçado
        </option>
        <option value="16101">16101 - Serração de madeira</option>
        <option value="16102">16102 - Impregnação de madeira</option>
        <option value="16211">
          16211 - Fabricação de painéis de partículas de madeira
        </option>
        <option value="16212">
          16212 - Fabricação de painéis de fibras de madeira
        </option>
        <option value="16213">16213 - Fabricação de folheados</option>
        <option value="16220">16220 - Parqueteria</option>
        <option value="16230">
          16230 - Fabricação de outras obras de carpintaria para a construção
        </option>
        <option value="16240">
          16240 - Fabricação de embalagens de madeira
        </option>
        <option value="16291">
          16291 - Fabricação de outras obras de madeira
        </option>
        <option value="16292">
          16292 - Fabricação de obras de cestaria e de espartaria
        </option>
        <option value="16293">
          16293 - Indústria de preparação da cortiça
        </option>
        <option value="16294">16294 - Fabricação de rolhas de cortiça</option>
        <option value="16295">
          16295 - Fabricação de outros produtos de cortiça
        </option>
        <option value="17110">17110 - Fabricação de pasta</option>
        <option value="17120">
          17120 - Fabricação de papel e de cartão (excepto canelado)
        </option>
        <option value="17211">
          17211 - Fabricação de papel e de cartão canelados (inclui embalagens)
        </option>
        <option value="17212">
          17212 - Fabricação de outras embalagens de papel e de cartão
        </option>
        <option value="17220">
          17220 - Fabricação de artigos de papel para uso doméstico e sanitário
        </option>
        <option value="17230">
          17230 - Fabricação de artigos de papel para papelaria
        </option>
        <option value="17240">17240 - Fabricação de papel de parede</option>
        <option value="17290">
          17290 - Fabricação de outros artigos de pasta de papel
        </option>
        <option value="18110">18110 - Impressão de jornais</option>
        <option value="18120">18120 - Outra impressão</option>
        <option value="18130">
          18130 - Actividades de preparação da impressão e de produtos media
        </option>
        <option value="18140">
          18140 - Encadernação e actividades relacionadas
        </option>
        <option value="18200">18200 - Reprodução de suportes gravados</option>
        <option value="19100">
          19100 - Fabricação de produtos de coqueria
        </option>
        <option value="19201">
          19201 - Fabricação de produtos petrolíferos refinados
        </option>
        <option value="19202">
          19202 - Fabricação de produtos petrolíferos a partir de resíduos
        </option>
        <option value="19203">
          19203 - Fabricação de briquetes e aglomerados de hulha e lenhite
        </option>
        <option value="20110">20110 - Fabricação de gases industriais</option>
        <option value="20120">
          20120 - Fabricação de corantes e pigmentos
        </option>
        <option value="20130">
          20130 - Fabricação de outros produtos químicos inorgânicos de base{" "}
        </option>
        <option value="20141">
          20141 - Fabricação de resinosos e seus derivados
        </option>
        <option value="20142">
          20142 - Fabricação de carvão (vegetal e animal) e produtos associados
        </option>
        <option value="20143">
          20143 - Fabricação de álcool etílico de fermentação
        </option>
        <option value="20144">
          20144 - Fabricação de outros produtos químicos orgânicos de base
        </option>
        <option value="20151">
          20151 - Fabricação de adubos químicos ou minerais e de compostos
          azotados
        </option>
        <option value="20152">
          20152 - Fabricação de adubos orgânicos e organo-minerais
        </option>
        <option value="20160">
          20160 - Fabricação de matérias plásticas sob formas primárias
        </option>
        <option value="20170">
          20170 - Fabricação de borracha sintética sob formas primárias
        </option>
        <option value="20200">
          20200 - Fabricação de pesticidas e de outros produtos agroquímicos
        </option>
        <option value="20301">
          20301 - Fabricação de tintas (excepto impressão)
        </option>
        <option value="20302">20302 - Fabricação de tintas de impressão</option>
        <option value="20303">
          20303 - Fabricação de pigmentos preparados
        </option>
        <option value="20411">20411 - Fabricação de sabões</option>
        <option value="20412">20412 - Fabricação de produtos de limpeza</option>
        <option value="20420">20420 - Fabricação de perfumes</option>
        <option value="20510">
          20510 - Fabricação de explosivos e artigos de pirotecnia
        </option>
        <option value="20520">20520 - Fabricação de colas</option>
        <option value="20530">20530 - Fabricação de óleos essenciais</option>
        <option value="20591">20591 - Fabricação de biodiesel</option>
        <option value="20592">
          20592 - Fabricação de produtos químicos auxiliares para uso industrial{" "}
        </option>
        <option value="20593">
          20593 - Fabricação de óleos e massas lubrificantes
        </option>
        <option value="20594">
          20594 - Fabricação de outros produtos químicos diversos
        </option>
        <option value="20600">
          20600 - Fabricação de fibras sintéticas ou artificiais
        </option>
        <option value="21100">
          21100 - Fabricação de produtos farmacêuticos de base
        </option>
        <option value="21201">21201 - Fabricação de medicamentos</option>
        <option value="21202">
          21202 - Fabricação de outras preparações e de artigos farmacêuticos
        </option>
        <option value="22111">
          22111 - Fabricação de pneus e câmaras-de-ar
        </option>
        <option value="22112">22112 - Reconstrução de pneus</option>
        <option value="22191">
          22191 - Fabricação de componentes de borracha para calçado
        </option>
        <option value="22192">
          22192 - Fabricação de outros produtos de borracha
        </option>
        <option value="22210">22210 - Fabricação de chapas</option>
        <option value="22220">
          22220 - Fabricação de embalagens de plástico
        </option>
        <option value="22230">
          22230 - Fabricação de artigos de plástico para a construção
        </option>
        <option value="22291">
          22291 - Fabricação de componentes de plástico para calçado
        </option>
        <option value="22292">
          22292 - Fabricação de outros artigos de plástico
        </option>
        <option value="23110">23110 - Fabricação de vidro plano</option>
        <option value="23120">
          23120 - Moldagem e transformação de vidro plano
        </option>
        <option value="23131">23131 - Fabricação de vidro de embalagem </option>
        <option value="23132">23132 - Cristalaria</option>
        <option value="23140">23140 - Fabricação de fibras de vidro</option>
        <option value="23190">
          23190 - Fabricação e transformação de outro vidro (inclui vidro
          técnico)
        </option>
        <option value="23200">
          23200 - Fabricação de produtos cerâmicos refractários
        </option>
        <option value="23311">23311 - Fabricação de azulejos </option>
        <option value="23312">23312 - Fabricação de ladrilhos</option>
        <option value="23321">23321 - Fabricação de tijolos</option>
        <option value="23322">23322 - Fabricação de telhas</option>
        <option value="23323">23323 - Fabricação de abobadilhas</option>
        <option value="23324">
          23324 - Fabricação de outros produtos cerâmicos para a construção
        </option>
        <option value="23411">23411 - Olaria de barro</option>
        <option value="23412">
          23412 - Fabricação de artigos de uso doméstico de faiança
        </option>
        <option value="23413">
          23413 - Fabricação de artigos de ornamentação de faiança
        </option>
        <option value="23414">
          23414 - Actividades de decoração de artigos cerâmicos de uso doméstico
          e ornamental
        </option>
        <option value="23420">
          23420 - Fabricação de artigos cerâmicos para usos sanitários
        </option>
        <option value="23430">
          23430 - Fabricação de isoladores e peças isolantes em cerâmica
        </option>
        <option value="23440">
          23440 - Fabricação de outros produtos em cerâmica para usos técnicos
        </option>
        <option value="23490">
          23490 - Fabricação de outros produtos cerâmicos não refractários
        </option>
        <option value="23510">23510 - Fabricação de cimento</option>
        <option value="23521">23521 - Fabricação de cal</option>
        <option value="23522">23522 - Fabricação de gesso</option>
        <option value="23610">
          23610 - Fabricação de produtos de betão para a construção
        </option>
        <option value="23620">
          23620 - Fabricação de produtos de gesso para a construção
        </option>
        <option value="23630">23630 - Fabricação de betão pronto</option>
        <option value="23640">23640 - Fabricação de argamassas</option>
        <option value="23650">
          23650 - Fabricação de produtos de fibrocimento
        </option>
        <option value="23690">
          23690 - Fabricação de outros produtos de betão
        </option>
        <option value="23701">
          23701 - Fabricação de artigos de mármore e de rochas similares{" "}
        </option>
        <option value="23702">
          23702 - Fabricação de artigos em ardósia (lousa)
        </option>
        <option value="23703">
          23703 - Fabricação de artigos de granito e de rochas
        </option>
        <option value="23910">23910 - Fabricação de produtos abrasivos</option>
        <option value="23991">
          23991 - Fabricação de misturas betuminosas
        </option>
        <option value="23992">
          23992 - Fabricação de outros produtos minerais não metálicos diversos
        </option>
        <option value="24100">
          24100 - Siderurgia e fabricação de ferro-ligas
        </option>
        <option value="24200">24200 - Fabricação de tubos</option>
        <option value="24310">24310 - Estiragem a frio</option>
        <option value="24320">24320 - Laminagem a frio de arco ou banda</option>
        <option value="24330">24330 - Perfilagem a frio</option>
        <option value="24340">24340 - Trefilagem a frio</option>
        <option value="24410">
          24410 - Obtenção e primeira transformação de metais preciosos
        </option>
        <option value="24420">
          24420 - Obtenção e primeira transformação de alumínio
        </option>
        <option value="24430">
          24430 - Obtenção e primeira transformação de chumbo
        </option>
        <option value="24440">
          24440 - Obtenção e primeira transformação de cobre
        </option>
        <option value="24450">
          24450 - Obtenção e primeira transformação de outros metais não
          ferrosos
        </option>
        <option value="24460">
          24460 - Tratamento de combustível nuclear{" "}
        </option>
        <option value="24510">24510 - Fundição de ferro fundido</option>
        <option value="24520">24520 - Fundição de aço</option>
        <option value="24530">24530 - Fundição de metais leves</option>
        <option value="24540">
          24540 - Fundição de outros metais não ferrosos
        </option>
        <option value="25110">
          25110 - Fabricação de estruturas de construções metálicas
        </option>
        <option value="25120">25120 - Fabricação de portas</option>
        <option value="25210">
          25210 - Fabricação de caldeiras e radiadores para aquecimento central
        </option>
        <option value="25290">
          25290 - Fabricação de outros reservatórios e recipientes metálicos
        </option>
        <option value="25300">
          25300 - Fabricação de geradores de vapor (excepto caldeiras para
          aquecimento central)
        </option>
        <option value="25401">25401 - Fabricação de armas de caça</option>
        <option value="25402">25402 - Fabricação de armamento</option>
        <option value="25501">25501 - Fabricação de produtos forjados</option>
        <option value="25502">
          25502 - Fabricação de produtos por pulverometalurgia
        </option>
        <option value="25610">
          25610 - Tratamento e revestimento de metais
        </option>
        <option value="25620">25620 - Actividades de mecânica geral</option>
        <option value="25710">25710 - Fabricação de cutelaria</option>
        <option value="25720">25720 - Fabricação de fechaduras</option>
        <option value="25731">25731 - Fabricação de ferramentas manuais</option>
        <option value="25732">
          25732 - Fabricação de ferramentas mecânicas
        </option>
        <option value="25733">25733 - Fabricação de peças sinterizadas </option>
        <option value="25734">25734 - Fabricação de moldes metálicos</option>
        <option value="25910">
          25910 - Fabricação de embalagens metálicas pesadas
        </option>
        <option value="25920">
          25920 - Fabricação de embalagens metálicas ligeiras
        </option>
        <option value="25931">25931 - Fabricação de produtos de arame</option>
        <option value="25932">25932 - Fabricação de molas</option>
        <option value="25933">25933 - Fabricação de correntes metálicas</option>
        <option value="25940">25940 - Fabricação de rebites</option>
        <option value="25991">
          25991 - Fabricação de louça metálica e artigos de uso doméstico
        </option>
        <option value="25992">
          25992 - Fabricação de outros produtos metálicos diversos
        </option>
        <option value="26110">
          26110 - Fabricação de componentes electrónicos
        </option>
        <option value="26120">
          26120 - Fabricação de placas de circuitos electrónicos
        </option>
        <option value="26200">
          26200 - Fabricação de computadores e de equipamento periférico
        </option>
        <option value="26300">
          26300 - Fabricação de aparelhos e equipamentos para comunicações
        </option>
        <option value="26400">
          26400 - Fabricação de receptores de rádio e de televisão e bens de
          consumo similares
        </option>
        <option value="26511">
          26511 - Fabricação de contadores de electricidade
        </option>
        <option value="26512">
          26512 - Fabricação de instrumentos e aparelhos de medida
        </option>
        <option value="26520">
          26520 - Fabricação de relógios e material de relojoaria
        </option>
        <option value="26600">
          26600 - Fabricação de equipamentos de radiação
        </option>
        <option value="26701">
          26701 - Fabricação de instrumentos e equipamentos ópticos não
          oftálmicos
        </option>
        <option value="26702">
          26702 - Fabricação de material fotográfico e cinematográfico
        </option>
        <option value="26800">
          26800 - Fabricação de suportes de informação magnéticos e ópticos
        </option>
        <option value="27110">27110 - Fabricação de motores</option>
        <option value="27121">
          27121 - Fabricação de material de distribuição e controlo para
          instalações eléctricas de alta tensão
        </option>
        <option value="27122">
          27122 - Fabricação de material de distribuição e controlo para
          instalações eléctricas de baixa tensão
        </option>
        <option value="27200">
          27200 - Fabricação de acumuladores e pilhas
        </option>
        <option value="27310">
          27310 - Fabricação de cabos de fibra óptica
        </option>
        <option value="27320">
          27320 - Fabricação de outros fios e cabos eléctricos e electrónicos
        </option>
        <option value="27330">
          27330 - Fabricação de dispositivos e acessórios para instalações
          eléctricas de baixa tensão
        </option>
        <option value="27400">
          27400 - Fabricação de lâmpadas eléctricas e de outro equipamento de
          iluminação
        </option>
        <option value="27510">27510 - Fabricação de electrodomésticos</option>
        <option value="27520">
          27520 - Fabricação de aparelhos não eléctricos para uso doméstico
        </option>
        <option value="27900">
          27900 - Fabricação de outro equipamento eléctrico
        </option>
        <option value="28110">28110 - Fabricação de motores e turbinas</option>
        <option value="28120">
          28120 - Fabricação de equipamento hidráulico e pneumático
        </option>
        <option value="28130">
          28130 - Fabricação de outras bombas e compressores
        </option>
        <option value="28140">
          28140 - Fabricação de outras torneiras e válvulas
        </option>
        <option value="28150">28150 - Fabricação de rolamentos</option>
        <option value="28210">
          28210 - Fabricação de fornos e queimadores
        </option>
        <option value="28221">
          28221 - Fabricação de ascensores e monta cargas
        </option>
        <option value="28222">
          28222 - Fabricação de equipamentos de elevação e de movimentação
        </option>
        <option value="28230">
          28230 - Fabricação de máquinas e equipamento de escritório
        </option>
        <option value="28240">
          28240 - Fabricação de máquinas-ferramentas portáteis com motor
        </option>
        <option value="28250">
          28250 - Fabricação de equipamento não doméstico para refrigeração e
          ventilação
        </option>
        <option value="28291">
          28291 - Fabricação de máquinas de acondicionamento e de embalagem
        </option>
        <option value="28292">
          28292 - Fabricação de balanças e de outro equipamento para pesagem{" "}
        </option>
        <option value="28293">
          28293 - Fabricação de outras máquinas diversas de uso geral
        </option>
        <option value="28300">
          28300 - Fabricação de máquinas e de tractores para a agricultura
        </option>
        <option value="28410">
          28410 - Fabricação de máquinas-ferramentas para metais
        </option>
        <option value="28490">
          28490 - Fabricação de outras máquinas-ferramentas
        </option>
        <option value="28910">
          28910 - Fabricação de máquinas para a metalurgia
        </option>
        <option value="28920">
          28920 - Fabricação de máquinas para as indústrias extractivas e para a
          construção
        </option>
        <option value="28930">
          28930 - Fabricação de máquinas para as indústrias alimentares
        </option>
        <option value="28940">
          28940 - Fabricação de máquinas para as indústrias têxtil
        </option>
        <option value="28950">
          28950 - Fabricação de máquinas para as indústrias do papel e do cartão
        </option>
        <option value="28960">
          28960 - Fabricação de máquinas para as indústrias do plástico e da
          borracha
        </option>
        <option value="28991">
          28991 - Fabricação de máquinas para as indústrias de materiais de
          construção
        </option>
        <option value="28992">
          28992 - Fabricação de outras máquinas diversas para uso específico
        </option>
        <option value="29100">29100 - Fabricação de veículos automóveis</option>
        <option value="29200">29200 - Fabricação de carroçarias</option>
        <option value="29310">
          29310 - Fabricação de equipamento eléctrico e electrónico para
          veículos automóveis
        </option>
        <option value="29320">
          29320 - Fabricação de outros componentes e acessórios para veículos
          automóveis
        </option>
        <option value="30111">
          30111 - Construção de embarcações metálicas e estruturas flutuantes
        </option>
        <option value="30112">
          30112 - Construção de embarcações não metálicas
        </option>
        <option value="30120">
          30120 - Construção de embarcações de recreio e de desporto
        </option>
        <option value="30200">
          30200 - Fabricação de material circulante para caminhos-de-ferro
        </option>
        <option value="30300">30300 - Fabricação de aeronaves</option>
        <option value="30400">
          30400 - Fabricação de veículos militares de combate
        </option>
        <option value="30910">30910 - Fabricação de motociclos</option>
        <option value="30920">
          30920 - Fabricação de bicicletas e veículos para inválidos
        </option>
        <option value="30990">
          30990 - Fabricação de outro equipamento de transporte
        </option>
        <option value="31010">
          31010 - Fabricação de mobiliário para escritório e comércio
        </option>
        <option value="31020">
          31020 - Fabricação de mobiliário de cozinha
        </option>
        <option value="31030">31030 - Fabricação de colchoaria</option>
        <option value="31091">
          31091 - Fabricação de mobiliário de madeira para outros fins
        </option>
        <option value="31092">
          31092 - Fabricação de mobiliário metálico para outros fins
        </option>
        <option value="31093">
          31093 - Fabricação de mobiliário de outros materiais para outros fins
        </option>
        <option value="31094">
          31094 - Actividades de acabamento de mobiliário
        </option>
        <option value="32110">32110 - Cunhagem de moedas</option>
        <option value="32121">32121 - Fabricação de filigranas</option>
        <option value="32122">
          32122 - Fabricação de artigos de joalharia e de outros artigos de
          ourivesaria
        </option>
        <option value="32123">
          32123 - Trabalho de diamantes e de outras pedras preciosas ou
          semi-preciosas para joalharia e uso industrial
        </option>
        <option value="32130">32130 - Fabricação de bijutarias</option>
        <option value="32200">
          32200 - Fabricação de instrumentos musicais
        </option>
        <option value="32300">32300 - Fabricação de artigos de desporto</option>
        <option value="32400">
          32400 - Fabricação de jogos e de brinquedos
        </option>
        <option value="32501">
          32501 - Fabricação de material óptico oftálmico
        </option>
        <option value="32502">
          32502 - Fabricação de material ortopédico e próteses e de instrumentos
          médico-cirúrgicos
        </option>
        <option value="32910">32910 - Fabricação de vassouras</option>
        <option value="32991">32991 - Fabricação de canetas</option>
        <option value="32992">32992 - Fabricação de fechos de correr</option>
        <option value="32993">
          32993 - Fabricação de guarda-sóis e chapéus de chuva
        </option>
        <option value="32994">
          32994 - Fabricação de equipamento de protecção e segurança
        </option>
        <option value="32995">
          32995 - Fabricação de caixões mortuários em madeira
        </option>
        <option value="32996">
          32996 - Outras indústrias transformadoras diversas
        </option>
        <option value="33110">
          33110 - Reparação e manutenção de produtos metálicos (excepto máquinas
          e equipamento)
        </option>
        <option value="33120">
          33120 - Reparação e manutenção de máquinas e equipamentos
        </option>
        <option value="33130">
          33130 - Reparação e manutenção de equipamento electrónico e óptico
        </option>
        <option value="33140">
          33140 - Reparação e manutenção de equipamento eléctrico
        </option>
        <option value="33150">
          33150 - Reparação e manutenção de embarcações
        </option>
        <option value="33160">
          33160 - Reparação e manutenção de aeronaves e de veículos espaciais
        </option>
        <option value="33170">
          33170 - Reparação e manutenção de outro equipamento de transporte
        </option>
        <option value="33190">
          33190 - Reparação e manutenção de outro equipamento
        </option>
        <option value="33200">
          33200 - Instalação de máquinas e de equipamentos industriais
        </option>
        <option value="35111">
          35111 - Produção de electricidade de origem hídrica
        </option>
        <option value="35112">
          35112 - Produção de electricidade de origem térmica
        </option>
        <option value="35113">
          35113 - Produção de electricidade de origem eólica
        </option>
        <option value="35120">35120 - Transporte de electricidade </option>
        <option value="35130">35130 - Distribuição de electricidade</option>
        <option value="35140">35140 - Comércio de electricidade</option>
        <option value="35210">35210 - Produção de gás</option>
        <option value="35220">
          35220 - Distribuição de combustíveis gasosos por condutas
        </option>
        <option value="35230">35230 - Comércio de gás por condutas</option>
        <option value="35301">35301 - Produção e distribuição de vapor</option>
        <option value="35302">35302 - Produção de gelo</option>
        <option value="36001">36001 - Captação e tratamento de água</option>
        <option value="36002">36002 - Distribuição de água</option>
        <option value="37001">
          37001 - Recolha e drenagem de águas residuais
        </option>
        <option value="37002">37002 - Tratamento de águas residuais</option>
        <option value="38111">38111 - Recolha de resíduos inertes</option>
        <option value="38112">
          38112 - Recolha de outros resíduos não perigosos
        </option>
        <option value="38120">38120 - Recolha de resíduos perigosos</option>
        <option value="38211">
          38211 - Tratamento e eliminação de resíduos inertes
        </option>
        <option value="38212">
          38212 - Tratamento e eliminação de outros resíduos não perigosos
        </option>
        <option value="38220">
          38220 - Tratamento e eliminação de resíduos perigosos
        </option>
        <option value="38311">
          38311 - Desmantelamento de veículos automóveis
        </option>
        <option value="38312">
          38312 - Desmantelamento de equipamentos eléctricos e electrónicos
        </option>
        <option value="38313">
          38313 - Desmantelamento de outros equipamentos e bens
        </option>
        <option value="38321">38321 - Valorização de resíduos metálicos</option>
        <option value="38322">
          38322 - Valorização de resíduos não metálicos
        </option>
        <option value="39000">
          39000 - Descontaminação e actividades similares
        </option>
        <option value="41100">
          41100 - Promoção imobiliária (desenvolvimento de projectos de
          edifícios)
        </option>
        <option value="41200">
          41200 - Construção de edifícios (residenciais e não residenciais)
        </option>
        <option value="42110">
          42110 - Construção de estradas e pistas de aeroportos
        </option>
        <option value="42120">42120 - Construção de vias férreas</option>
        <option value="42130">42130 - Construção de pontes e túneis</option>
        <option value="42210">
          42210 - Construção de redes de transporte de águas
        </option>
        <option value="42220">
          42220 - Construção de redes de transporte e distribuição de
          electricidade e redes de telecomunicações
        </option>
        <option value="42910">42910 - Engenharia hidráulica</option>
        <option value="42990">
          42990 - Construção de outras obras de engenharia civil
        </option>
        <option value="43110">43110 - Demolição</option>
        <option value="43120">
          43120 - Preparação dos locais de construção
        </option>
        <option value="43130">43130 - Perfurações e sondagens</option>
        <option value="43210">43210 - Instalação eléctrica</option>
        <option value="43221">43221 - Instalação de canalizações</option>
        <option value="43222">43222 - Instalação de climatização</option>
        <option value="43290">43290 - Outras instalações em construções</option>
        <option value="43310">43310 - Estucagem</option>
        <option value="43320">
          43320 - Montagem de trabalhos de carpintaria e de caixilharia
        </option>
        <option value="43330">
          43330 - Revestimento de pavimentos e de paredes
        </option>
        <option value="43340">43340 - Pintura e colocação de vidros</option>
        <option value="43390">
          43390 - Outras actividades de acabamento em edifícios
        </option>
        <option value="43910">
          43910 - Actividades de colocação de coberturas
        </option>
        <option value="43991">
          43991 - Aluguer de equipamento de construção e de demolição
        </option>
        <option value="43992">
          43992 - Outras actividades especializadas de construção diversas
        </option>
        <option value="45110">
          45110 - Comércio de veículos automóveis ligeiros
        </option>
        <option value="45190">
          45190 - Comércio de outros veículos automóveis
        </option>
        <option value="45200">
          45200 - Manutenção e reparação de veículos automóveis
        </option>
        <option value="45310">
          45310 - Comércio por grosso de peças e acessórios para veículos
          automóveis
        </option>
        <option value="45320">
          45320 - Comércio a retalho de peças e acessórios para veículos
          automóveis
        </option>
        <option value="45401">
          45401 - Comércio por grosso e a retalho de motociclos
        </option>
        <option value="45402">
          45402 - Manutenção e reparação de motociclos
        </option>
        <option value="46110">
          46110 - Agentes do comércio por grosso de matérias-primas agrícolas e
          têxteis
        </option>
        <option value="46120">
          46120 - Agentes do comércio por grosso de combustíveis
        </option>
        <option value="46130">
          46130 - Agentes do comércio por grosso de madeira e materiais de
          construção
        </option>
        <option value="46140">
          46140 - Agentes do comércio por grosso de máquinas
        </option>
        <option value="46150">
          46150 - Agentes do comércio por grosso de mobiliário
        </option>
        <option value="46160">
          46160 - Agentes do comércio por grosso de têxteis
        </option>
        <option value="46170">
          46170 - Agentes do comércio por grosso de produtos alimentares
        </option>
        <option value="46180">
          46180 - Agentes especializados do comércio por grosso de outros
          produtos
        </option>
        <option value="46190">
          46190 - Agentes do comércio por grosso misto sem predominância
        </option>
        <option value="46211">
          46211 - Comércio por grosso de alimentos para animais
        </option>
        <option value="46212">
          46212 - Comércio por grosso de tabaco em bruto
        </option>
        <option value="46213">
          46213 - Comércio por grosso de cortiça em bruto
        </option>
        <option value="46214">46214 - Comércio por grosso de cereais</option>
        <option value="46220">
          46220 - Comércio por grosso de flores e plantas
        </option>
        <option value="46230">
          46230 - Comércio por grosso de animais vivos
        </option>
        <option value="46240">
          46240 - Comércio por grosso de peles e couro
        </option>
        <option value="46311">
          46311 - Comércio por grosso de fruta e de produtos hortícolas
        </option>
        <option value="46312">46312 - Comércio por grosso de batata</option>
        <option value="46320">
          46320 - Comércio por grosso de carne e produtos à base de carne
        </option>
        <option value="46331">46331 - Comércio por grosso de leite</option>
        <option value="46332">46332 - Comércio por grosso de azeite</option>
        <option value="46341">
          46341 - Comércio por grosso de bebidas alcoólicas
        </option>
        <option value="46342">
          46342 - Comércio por grosso de bebidas não alcoólicas
        </option>
        <option value="46350">46350 - Comércio por grosso de tabaco</option>
        <option value="46361">46361 - Comércio por grosso de açúcar</option>
        <option value="46362">
          46362 - Comércio por grosso de chocolate e de produtos de confeitaria
        </option>
        <option value="46370">46370 - Comércio por grosso de café</option>
        <option value="46381">46381 - Comércio por grosso de peixe</option>
        <option value="46382">
          46382 - Comércio por grosso de outros produtos alimentares
        </option>
        <option value="46390">
          46390 - Comércio por grosso não especializado de produtos alimentares
        </option>
        <option value="46410">46410 - Comércio por grosso de têxteis</option>
        <option value="46421">
          46421 - Comércio por grosso de vestuário e de acessórios
        </option>
        <option value="46422">46422 - Comércio por grosso de calçado</option>
        <option value="46430">
          46430 - Comércio por grosso de electrodomésticos
        </option>
        <option value="46441">
          46441 - Comércio por grosso de louças em cerâmica e em vidro
        </option>
        <option value="46442">
          46442 - Comércio por grosso de produtos de limpeza
        </option>
        <option value="46450">
          46450 - Comércio por grosso de perfumes e de produtos de higiene
        </option>
        <option value="46460">
          46460 - Comércio por grosso de produtos farmacêuticos
        </option>
        <option value="46470">
          46470 - Comércio por grosso de móveis para uso doméstico
        </option>
        <option value="46480">
          46480 - Comércio por grosso de relógios e de artigos de ourivesaria e
          joalharia
        </option>
        <option value="46491">
          46491 - Comércio por grosso de artigos de papelaria
        </option>
        <option value="46492">46492 - Comércio por grosso de livros</option>
        <option value="46493">46493 - Comércio por grosso de brinquedos</option>
        <option value="46494">
          46494 - Outro comércio por grosso de bens de consumo
        </option>
        <option value="46510">
          46510 - Comércio por grosso de computadores
        </option>
        <option value="46520">
          46520 - Comércio por grosso de equipamentos electrónicos
        </option>
        <option value="46610">
          46610 - Comércio por grosso de máquinas e equipamentos
        </option>
        <option value="46620">
          46620 - Comércio por grosso de máquinas-ferramentas
        </option>
        <option value="46630">
          46630 - Comércio por grosso de máquinas para a indústria extractiva
        </option>
        <option value="46640">
          46640 - Comércio por grosso de máquinas para a indústria têxtil
        </option>
        <option value="46650">
          46650 - Comércio por grosso de mobiliário de escritório
        </option>
        <option value="46660">
          46660 - Comércio por grosso de outras máquinas e material de
          escritório
        </option>
        <option value="46690">
          46690 - Comércio por grosso de outras máquinas e equipamentos
        </option>
        <option value="46711">
          46711 - Comércio por grosso de produtos petrolíferos
        </option>
        <option value="46712">
          46712 - Comércio por grosso de combustíveis sólidos
        </option>
        <option value="46720">
          46720 - Comércio por grosso de minérios e de metais
        </option>
        <option value="46731">
          46731 - Comércio por grosso de madeira em bruto e de produtos
          derivados
        </option>
        <option value="46732">
          46732 - Comércio por grosso de materiais de construção (excepto
          madeira) e equipamento sanitário
        </option>
        <option value="46740">46740 - Comércio por grosso de ferragens</option>
        <option value="46750">
          46750 - Comércio por grosso de produtos químicos
        </option>
        <option value="46761">
          46761 - Comércio por grosso de fibras têxteis naturais
        </option>
        <option value="46762">
          46762 - Comércio por grosso de outros bens intermédios
        </option>
        <option value="46771">
          46771 - Comércio por grosso de sucatas e de desperdícios metálicos
        </option>
        <option value="46772">
          46772 - Comércio por grosso de desperdícios têxteis
        </option>
        <option value="46773">
          46773 - Comércio por grosso de desperdícios de materiais
        </option>
        <option value="46900">
          46900 - Comércio por grosso não especializado
        </option>
        <option value="47111">
          47111 - Comércio a retalho em supermercados e hipermercados
        </option>
        <option value="47112">
          47112 - Comércio a retalho em outros estabelecimentos não
          especializados
        </option>
        <option value="47191">
          47191 - Comércio a retalho não especializado
        </option>
        <option value="47192">
          47192 - Comércio a retalho em outros estabelecimentos não
          especializados
        </option>
        <option value="47210">
          47210 - Comércio a retalho de frutas e produtos hortícolas
        </option>
        <option value="47220">
          47220 - Comércio a retalho de carne e produtos à base de carne
        </option>
        <option value="47230">47230 - Comércio a retalho de peixe</option>
        <option value="47240">47240 - Comércio a retalho de pão</option>
        <option value="47250">47250 - Comércio a retalho de bebidas</option>
        <option value="47260">47260 - Comércio a retalho de tabaco</option>
        <option value="47291">
          47291 - Comércio a retalho de leite e de derivados
        </option>
        <option value="47292">
          47292 - Comércio a retalho de produtos alimentares
        </option>
        <option value="47293">
          47293 - Outro comércio a retalho de produtos alimentares
        </option>
        <option value="47300">
          47300 - Comércio a retalho de combustível para veículos a motor
        </option>
        <option value="47410">
          47410 - Comércio a retalho de computadores
        </option>
        <option value="47420">
          47420 - Comércio a retalho de equipamento de telecomunicações
        </option>
        <option value="47430">
          47430 - Comércio a retalho de equipamento audiovisual
        </option>
        <option value="47510">47510 - Comércio a retalho de têxteis</option>
        <option value="47521">
          47521 - Comércio a retalho de ferragens e de vidro plano
        </option>
        <option value="47522">47522 - Comércio a retalho de tintas</option>
        <option value="47523">
          47523 - Comércio a retalho de material de bricolage
        </option>
        <option value="47530">47530 - Comércio a retalho de carpetes</option>
        <option value="47540">
          47540 - Comércio a retalho de electrodomésticos
        </option>
        <option value="47591">
          47591 - Comércio a retalho de mobiliário e artigos de iluminação
        </option>
        <option value="47592">47592 - Comércio a retalho de louças</option>
        <option value="47593">
          47593 - Comércio a retalho de outros artigos para o lar
        </option>
        <option value="47610">47610 - Comércio a retalho de livros</option>
        <option value="47620">47620 - Comércio a retalho de jornais</option>
        <option value="47630">47630 - Comércio a retalho de discos,</option>
        <option value="47640">
          47640 - Comércio a retalho de artigos de desporto
        </option>
        <option value="47650">
          47650 - Comércio a retalho de jogos e brinquedos
        </option>
        <option value="47711">
          47711 - Comércio a retalho de vestuário para adultos
        </option>
        <option value="47712">
          47712 - Comércio a retalho de vestuário para bebés e crianças
        </option>
        <option value="47721">47721 - Comércio a retalho de calçado</option>
        <option value="47722">
          47722 - Comércio a retalho de marroquinaria e artigos de viagem
        </option>
        <option value="47730">
          47730 - Comércio a retalho de produtos farmacêuticos
        </option>
        <option value="47740">
          47740 - Comércio a retalho de produtos médicos e ortopédicos
        </option>
        <option value="47750">
          47750 - Comércio a retalho de produtos cosméticos e de higiene
        </option>
        <option value="47761">47761 - Comércio a retalho de flores</option>
        <option value="47762">
          47762 - Comércio a retalho de animais de companhia e respectivos
          alimentos
        </option>
        <option value="47770">
          47770 - Comércio a retalho de relógios e de artigos de ourivesaria e
          joalharia
        </option>
        <option value="47781">
          47781 - Comércio a retalho de máquinas e de outro material de
          escritório
        </option>
        <option value="47782">
          47782 - Comércio a retalho de material óptico
        </option>
        <option value="47783">
          47783 - Comércio a retalho de combustíveis para uso doméstico
        </option>
        <option value="47784">
          47784 - Comércio a retalho de outros produtos novos
        </option>
        <option value="47790">
          47790 - Comércio a retalho de artigos em segunda mão
        </option>
        <option value="47810">47810 - Comércio a retalho em bancas</option>
        <option value="47820">
          47820 - Comércio a retalho em bancas, malas e similares
        </option>
        <option value="47890">47890 - Comércio a retalho em bancas</option>
        <option value="47910">
          47910 - Comércio a retalho por correspondência ou via Internet
        </option>
        <option value="47990">
          47990 - Comércio a retalho por outros métodos
        </option>
        <option value="49100">
          49100 - Transporte interurbano de passageiros por caminho-de-ferro
        </option>
        <option value="49200">
          49200 - Transporte de mercadorias por caminhos-de-ferro
        </option>
        <option value="49310">49310 - Transportes terrestres</option>
        <option value="49320">
          49320 - Transporte ocasional de passageiros em veículos ligeiros
        </option>
        <option value="49391">
          49391 - Transporte interurbano em autocarros
        </option>
        <option value="49392">
          49392 - Outros transportes terrestres de passageiros diversos
        </option>
        <option value="49410">
          49410 - Transportes rodoviários de mercadorias
        </option>
        <option value="49420">49420 - Actividades de mudanças</option>
        <option value="49500">
          49500 - Transportes por oleodutos ou gasodutos{" "}
        </option>
        <option value="50101">
          50101 - Transportes marítimos não costeiros de passageiros
        </option>
        <option value="50102">
          50102 - Transportes costeiros e locais de passageiros
        </option>
        <option value="50200">
          50200 - Transportes marítimos de mercadorias{" "}
        </option>
        <option value="50300">
          50300 - Transportes de passageiros por vias navegáveis interiores{" "}
        </option>
        <option value="50400">
          50400 - Transportes de mercadorias por vias navegáveis interiores
        </option>
        <option value="51100">51100 - Transportes aéreos de passageiros</option>
        <option value="51210">51210 - Transportes aéreos de mercadorias</option>
        <option value="51220">51220 - Transportes espaciais</option>
        <option value="52101">52101 - Armazenagem frigorífica</option>
        <option value="52102">52102 - Armazenagem não frigorífica</option>
        <option value="52211">
          52211 - Gestão de infra-estruturas dos transportes terrestres
        </option>
        <option value="52212">52212 - Assistência a veículos na estrada</option>
        <option value="52213">
          52213 - Outras actividades auxiliares dos transportes terrestres
        </option>
        <option value="52220">
          52220 - Actividades auxiliares dos transportes por água
        </option>
        <option value="52230">
          52230 - Actividades auxiliares dos transportes aéreos
        </option>
        <option value="52240">52240 - Manuseamento de carga</option>
        <option value="52291">52291 - Organização do transporte</option>
        <option value="52292">
          52292 - Agentes aduaneiros e similares de apoio ao transporte
        </option>
        <option value="53100">
          53100 - Actividades postais sujeitas a obrigações do serviço universal
        </option>
        <option value="53200">
          53200 - Outras actividades postais e de courier
        </option>
        <option value="55111">55111 - Hotéis com restaurante</option>
        <option value="55112">55112 - Pensões com restaurante</option>
        <option value="55113">55113 - Estalagens com restaurante</option>
        <option value="55114">55114 - Pousadas com restaurante</option>
        <option value="55115">55115 - Motéis com restaurante</option>
        <option value="55116">
          55116 - Hotéis-Apartamentos com restaurante
        </option>
        <option value="55117">
          55117 - Aldeamentos turísticos com restaurante
        </option>
        <option value="55118">
          55118 - Apartamentos turísticos com restaurante
        </option>
        <option value="55119">
          55119 - Outros estabelecimentos hoteleiros com restaurante
        </option>
        <option value="55121">55121 - Hotéis sem restaurante</option>
        <option value="55122">55122 - Pensões sem restaurante</option>
        <option value="55123">
          55123 - Apartamentos turísticos sem restaurante
        </option>
        <option value="55124">
          55124 - Outros estabelecimentos hoteleiros sem restaurante
        </option>
        <option value="55201">55201 - Alojamento mobilado para turistas</option>
        <option value="55202">55202 - Turismo no espaço rural</option>
        <option value="55203">55203 - Colónias e campos de férias </option>
        <option value="55204">
          55204 - Outros locais de alojamento de curta duração{" "}
        </option>
        <option value="55300">
          55300 - Parques de campismo e de caravanismo
        </option>
        <option value="55900">55900 - Outros locais de alojamento</option>
        <option value="56101">56101 - Restaurantes tipo tradicional</option>
        <option value="56102">
          56102 - Restaurantes com lugares ao balcão
        </option>
        <option value="56103">56103 - Restaurantes sem serviço de mesa </option>
        <option value="56104">56104 - Restaurantes típicos</option>
        <option value="56105">56105 - Restaurantes com espaço de dança</option>
        <option value="56106">
          56106 - Confecção de refeições prontas a levar para casa
        </option>
        <option value="56107">56107 - Restaurantes</option>
        <option value="56210">
          56210 - Fornecimento de refeições para eventos
        </option>
        <option value="56290">
          56290 - Outras actividades de serviço de refeições
        </option>
        <option value="56301">56301 - Cafés</option>
        <option value="56302">56302 - Bares</option>
        <option value="56303">56303 - Pastelarias e casas de chá</option>
        <option value="56304">
          56304 - Outros estabelecimentos de bebidas sem espectáculo
        </option>
        <option value="56305">
          56305 - Estabelecimentos de bebidas com espaço de dança{" "}
        </option>
        <option value="58110">58110 - Edição de livros</option>
        <option value="58120">
          58120 - Edição de listas destinadas a consulta
        </option>
        <option value="58130">58130 - Edição de jornais</option>
        <option value="58140">
          58140 - Edição de revistas e de outras publicações periódicas
        </option>
        <option value="58190">58190 - Outras actividades de edição</option>
        <option value="58210">58210 - Edição de jogos de computador</option>
        <option value="58290">
          58290 - Edição de outros programas informáticos
        </option>
        <option value="59110">59110 - Produção de filmes</option>
        <option value="59120">
          59120 - Actividades técnicas de pós-produção para filmes
        </option>
        <option value="59130">59130 - Distribuição de filmes</option>
        <option value="59140">59140 - Projecção de filmes e de vídeos</option>
        <option value="59200">
          59200 - Actividades de gravação de som e edição de música
        </option>
        <option value="60100">60100 - Actividades de rádio</option>
        <option value="60200">60200 - Actividades de televisão</option>
        <option value="61100">
          61100 - Actividades de telecomunicações por fio
        </option>
        <option value="61200">
          61200 - Actividades de telecomunicações sem fio
        </option>
        <option value="61300">
          61300 - Actividades de telecomunicações por satélite
        </option>
        <option value="61900">
          61900 - Outras actividades de telecomunicações
        </option>
        <option value="62010">
          62010 - Actividades de programação informática
        </option>
        <option value="62020">
          62020 - Actividades de consultoria em informática
        </option>
        <option value="62030">
          62030 - Gestão e exploração de equipamento informático
        </option>
        <option value="62090">
          62090 - Outras actividades relacionadas com as tecnologias da
          informação e informática
        </option>
        <option value="63110">
          63110 - Actividades de processamento de dados
        </option>
        <option value="63120">63120 - Portais Web</option>
        <option value="63910">
          63910 - Actividades de agências de notícias
        </option>
        <option value="63990">
          63990 - Outras actividades dos serviços de informação
        </option>
        <option value="64110">64110 - Banco central</option>
        <option value="64190">64190 - Outra intermediação monetária</option>
        <option value="64201">
          64201 - Actividades das sociedades gestoras de participações sociais
          financeiras
        </option>
        <option value="64202">
          64202 - Actividades das sociedades gestoras de participações sociais
          não financeiras
        </option>
        <option value="64300">64300 - Trusts</option>
        <option value="64910">64910 - Actividades de locação financeira</option>
        <option value="64921">
          64921 - Actividades das instituições financeiras de crédito
        </option>
        <option value="64922">
          64922 - Actividades das sociedades financeiras para aquisições a
          crédito
        </option>
        <option value="64923">64923 - Outras actividades de crédito</option>
        <option value="64991">64991 - Actividades de factoring</option>
        <option value="64992">
          64992 - Outras actividades de serviços financeiros diversos
        </option>
        <option value="65111">65111 - Seguros de vida</option>
        <option value="65112">
          65112 - Outras actividades complementares de segurança social
        </option>
        <option value="65120">65120 - Seguros não vida</option>
        <option value="65200">65200 - Resseguros</option>
        <option value="65300">
          65300 - Fundos de pensões e regimes profissionais complementares
        </option>
        <option value="66110">
          66110 - Administração de mercados financeiros
        </option>
        <option value="66120">
          66120 - Actividades de negociação por conta de terceiros em valores
          mobiliários e outros instrumentos financeiros
        </option>
        <option value="66190">
          66190 - Outras actividades auxiliares de serviços financeiros
        </option>
        <option value="66210">
          66210 - Actividades de avaliação de riscos e danos
        </option>
        <option value="66220">
          66220 - Actividades de mediadores de seguros
        </option>
        <option value="66290">
          66290 - Outras actividades auxiliares de seguros e fundos de pensões
        </option>
        <option value="66300">66300 - Actividades de gestão de fundos</option>
        <option value="68100">
          68100 - Compra e venda de bens imobiliários
        </option>
        <option value="68200">68200 - Arrendamento de bens imobiliários</option>
        <option value="68311">
          68311 - Actividades de mediação imobiliária
        </option>
        <option value="68312">
          68312 - Actividades de angariação imobiliária
        </option>
        <option value="68313">
          68313 - Actividades de avaliação imobiliária
        </option>
        <option value="68321">
          68321 - Administração de imóveis por conta de outrem
        </option>
        <option value="68322">68322 - Administração de condomínios</option>
        <option value="69101">69101 - Actividades jurídicas</option>
        <option value="69102">
          69102 - Actividades dos cartórios notariais
        </option>
        <option value="69200">
          69200 - Actividades de contabilidade e auditoria; consultoria fiscal
        </option>
        <option value="70100">70100 - Actividades das sedes sociais</option>
        <option value="70210">
          70210 - Actividades de relações públicas e comunicação
        </option>
        <option value="70220">
          70220 - Outras actividades de consultoria para os negócios e a gestão
        </option>
        <option value="71110">71110 - Actividades de arquitectura</option>
        <option value="71120">
          71120 - Actividades de engenharia e técnicas afins
        </option>
        <option value="71200">
          71200 - Actividades de ensaios e análises técnicas
        </option>
        <option value="72110">
          72110 - Investigação e desenvolvimento em biotecnologia
        </option>
        <option value="72190">
          72190 - Outra investigação e desenvolvimento das ciências físicas e
          naturais
        </option>
        <option value="72200">
          72200 - Investigação e desenvolvimento das ciências sociais e humanas
        </option>
        <option value="73110">73110 - Agências de publicidade</option>
        <option value="73120">
          73120 - Actividades de representação nos meios de comunicação
        </option>
        <option value="73200">
          73200 - Estudos de mercado e sondagens de opinião
        </option>
        <option value="74100">74100 - Actividades de design</option>
        <option value="74200">74200 - Actividades fotográficas</option>
        <option value="74300">
          74300 - Actividades de tradução e interpretação
        </option>
        <option value="74900">74900 - Outras actividades de consultoria</option>
        <option value="75000">75000 - Actividades veterinárias</option>
        <option value="77110">
          77110 - Aluguer de veículos automóveis ligeiros
        </option>
        <option value="77120">
          77120 - Aluguer de veículos automóveis pesados
        </option>
        <option value="77210">
          77210 - Aluguer de bens recreativos e desportivos
        </option>
        <option value="77220">77220 - Aluguer de videocassetes e discos</option>
        <option value="77290">
          77290 - Aluguer de outros bens de uso pessoal e doméstico
        </option>
        <option value="77310">
          77310 - Aluguer de máquinas e equipamentos agrícolas
        </option>
        <option value="77320">
          77320 - Aluguer de máquinas e equipamentos para a construção e
          engenharia civil
        </option>
        <option value="77330">
          77330 - Aluguer de máquinas e equipamentos de escritório (inclui
          computadores)
        </option>
        <option value="77340">
          77340 - Aluguer de meios de transporte marítimo e fluvial
        </option>
        <option value="77350">
          77350 - Aluguer de meios de transporte aéreo
        </option>
        <option value="77390">
          77390 - Aluguer de outras máquinas e equipamentos
        </option>
        <option value="77400">
          77400 - Locação de propriedade intelectual e produtos similares
        </option>
        <option value="78100">
          78100 - Actividades das empresas de selecção e colocação de pessoal
        </option>
        <option value="78200">
          78200 - Actividades das empresas de trabalho temporário
        </option>
        <option value="78300">
          78300 - Outro fornecimento de recursos humanos
        </option>
        <option value="79110">
          79110 - Actividades das agências de viagem
        </option>
        <option value="79120">
          79120 - Actividades dos operadores turísticos
        </option>
        <option value="79900">
          79900 - Outros serviços de reservas e actividades relacionadas
        </option>
        <option value="80100">80100 - Actividades de segurança privada</option>
        <option value="80200">
          80200 - Actividades relacionadas com sistemas de segurança
        </option>
        <option value="80300">80300 - Actividades de investigação</option>
        <option value="81100">
          81100 - Actividades combinadas de apoio aos edifícios
        </option>
        <option value="81210">
          81210 - Actividades de limpeza geral em edifícios
        </option>
        <option value="81220">
          81220 - Outras actividades de limpeza em edifícios e em equipamentos
          industriais
        </option>
        <option value="81291">81291 - Actividades de desinfecção</option>
        <option value="81292">81292 - Outras actividades de limpeza</option>
        <option value="81300">
          81300 - Actividades de plantação e manutenção de jardins
        </option>
        <option value="82110">
          82110 - Actividades combinadas de serviços administrativos
        </option>
        <option value="82190">82190 - Execução de fotocópias</option>
        <option value="82200">
          82200 - Actividades dos centros de chamadas
        </option>
        <option value="82300">82300 - Organização de feiras</option>
        <option value="82910">
          82910 - Actividades de cobranças e avaliação de crédito
        </option>
        <option value="82921">82921 - Engarrafamento de gases</option>
        <option value="82922">82922 - Outras actividades de embalagem</option>
        <option value="82990">
          82990 - Outras actividades de serviços de apoio prestados às empresas
        </option>
        <option value="84111">84111 - Administração Central</option>
        <option value="84112">84112 - Administração Regional Autónoma</option>
        <option value="84113">84113 - Administração Local</option>
        <option value="84114">
          84114 - Actividades de apoio à administração pública
        </option>
        <option value="84121">
          84121 - Administração Pública - actividades de saúde
        </option>
        <option value="84122">
          84122 - Administração Pública - actividades de educação
        </option>
        <option value="84123">
          84123 - Administração Pública - actividades da cultura, excepto
          segurança social obrigatória
        </option>
        <option value="84130">
          84130 - Administração pública - actividades económicas
        </option>
        <option value="84210">84210 - Negócios estrangeiros</option>
        <option value="84220">84220 - Actividades de defesa</option>
        <option value="84230">84230 - Actividades de justiça</option>
        <option value="84240">
          84240 - Actividades de segurança e ordem pública
        </option>
        <option value="84250">84250 - Actividades de protecção civil</option>
        <option value="84300">
          84300 - Actividades de segurança social obrigatória
        </option>
        <option value="85100">85100 - Educação pré-escolar</option>
        <option value="85201">85201 - Ensino básico (1º Ciclo)</option>
        <option value="85202">85202 - Ensino básico (2º Ciclo)</option>
        <option value="85310">
          85310 - Ensinos básico (3º Ciclo) e secundário geral
        </option>
        <option value="85320">85320 - Ensinos secundário tecnológico</option>
        <option value="85410">
          85410 - Ensino pós-secundário não superior
        </option>
        <option value="85420">85420 - Ensino superior</option>
        <option value="85510">85510 - Ensinos desportivo e recreativo</option>
        <option value="85520">85520 - Ensino de actividades culturais</option>
        <option value="85530">85530 - Escolas de condução e pilotagem</option>
        <option value="85591">85591 - Formação profissional</option>
        <option value="85592">85592 - Escolas de línguas</option>
        <option value="85593">85593 - Outras actividades educativas</option>
        <option value="85600">
          85600 - Actividades de serviços de apoio à educação
        </option>
        <option value="86100">
          86100 - Actividades dos estabelecimentos de saúde com internamento
        </option>
        <option value="86210">
          86210 - Actividades de prática médica de clínica geral
        </option>
        <option value="86220">
          86220 - Actividades de prática médica de clínica especializada
        </option>
        <option value="86230">
          86230 - Actividades de medicina dentária e odontologia
        </option>
        <option value="86901">86901 - Laboratórios de análises clínicas</option>
        <option value="86902">86902 - Actividades de ambulâncias</option>
        <option value="86903">86903 - Actividades de enfermagem </option>
        <option value="86904">
          86904 - Centros de recolha e bancos de órgãos{" "}
        </option>
        <option value="86905">86905 - Actividades termais</option>
        <option value="86906">
          86906 - Outras actividades de saúde humana
        </option>
        <option value="87100">
          87100 - Actividades dos estabelecimentos de cuidados continuados
          integrados
        </option>
        <option value="87200">
          87200 - Actividades dos estabelecimentos para pessoas com doença do
          foro mental e do abuso de drogas
        </option>
        <option value="87301">
          87301 - Actividades de apoio social para pessoas idosas
        </option>
        <option value="87302">
          87302 - Actividades de apoio social para pessoas com deficiência
        </option>
        <option value="87901">
          87901 - Actividades de apoio social para crianças e jovens
        </option>
        <option value="87902">
          87902 - Actividades de apoio social com alojamento
        </option>
        <option value="88101">
          88101 - Actividades de apoio social para pessoas idosas
        </option>
        <option value="88102">
          88102 - Actividades de apoio social para pessoas com deficiência
        </option>
        <option value="88910">
          88910 - Actividades de cuidados para crianças
        </option>
        <option value="88990">
          88990 - Outras actividades de apoio social sem alojamento
        </option>
        <option value="90010">
          90010 - Actividades das artes do espectáculo
        </option>
        <option value="90020">
          90020 - Actividades de apoio às artes do espectáculo
        </option>
        <option value="90030">90030 - Criação artística e literária</option>
        <option value="90040">
          90040 - Exploração de salas de espectáculos e actividades conexas
        </option>
        <option value="91011">91011 - Actividades das bibliotecas</option>
        <option value="91012">91012 - Actividades dos arquivos</option>
        <option value="91020">91020 - Actividades dos museus</option>
        <option value="91030">
          91030 - Actividades dos sítios e monumentos históricos
        </option>
        <option value="91041">
          91041 - Actividades dos jardins zoológicos
        </option>
        <option value="91042">
          91042 - Actividade dos parques e reservas naturais{" "}
        </option>
        <option value="92000">92000 - Lotarias e outros jogos de aposta</option>
        <option value="93110">93110 - Gestão de instalações desportivas</option>
        <option value="93120">
          93120 - Actividades dos clubes desportivos
        </option>
        <option value="93130">93130 - Actividades de ginásio (fitness)</option>
        <option value="93191">
          93191 - Organismos reguladores das actividades desportivas
        </option>
        <option value="93192">93192 - Outras actividades desportivas</option>
        <option value="93210">
          93210 - Actividades dos parques de diversão e temáticos
        </option>
        <option value="93291">93291 - Actividades tauromáquicas</option>
        <option value="93292">
          93292 - Actividades dos portos de recreio (marinas)
        </option>
        <option value="93293">
          93293 - Organização de actividades de animação turística
        </option>
        <option value="93294">
          93294 - Outras actividades de diversão e recreativas
        </option>
        <option value="94110">
          94110 - Actividades de organizações económicas e patronais
        </option>
        <option value="94120">
          94120 - Actividades de organizações profissionais
        </option>
        <option value="94200">
          94200 - Actividades de organizações sindicais
        </option>
        <option value="94910">
          94910 - Actividades de organizações religiosas
        </option>
        <option value="94920">
          94920 - Actividades de organizações políticas
        </option>
        <option value="94991">
          94991 - Associações culturais e recreativas
        </option>
        <option value="94992">94992 - Associações de defesa do ambiente</option>
        <option value="94993">
          94993 - Associações de juventude e de estudantes
        </option>
        <option value="94994">
          94994 - Associações de pais e encarregados de educação
        </option>
        <option value="94995">94995 - Outras actividades associativas</option>
        <option value="95110">
          95110 - Reparação de computadores e de equipamento periférico
        </option>
        <option value="95120">
          95120 - Reparação de equipamento de comunicação
        </option>
        <option value="95210">
          95210 - Reparação de televisores e de outros bens de consumo similares
        </option>
        <option value="95220">
          95220 - Reparação de electrodomésticos e de outros equipamentos de uso
          doméstico e para jardim
        </option>
        <option value="95230">
          95230 - Reparação de calçado e de artigos de couro
        </option>
        <option value="95240">
          95240 - Reparação de mobiliário e similares
        </option>
        <option value="95250">
          95250 - Reparação de relógios e de artigos de joalharia
        </option>
        <option value="95290">
          95290 - Reparação de outros bens de uso pessoal e doméstico
        </option>
        <option value="96010">
          96010 - Lavagem e limpeza a seco de têxteis e peles
        </option>
        <option value="96021">96021 - Salões de cabeleireiro</option>
        <option value="96022">96022 - Institutos de beleza</option>
        <option value="96030">96030 - Actividades funerárias e conexas</option>
        <option value="96040">96040 - Actividades de bem-estar físico</option>
        <option value="96091">
          96091 - Actividades de tatuagem e similares
        </option>
        <option value="96092">
          96092 - Actividades dos serviços para animais de companhia
        </option>
        <option value="96093">
          96093 - Outras actividades de serviços pessoais diversas
        </option>
        <option value="97000">
          97000 - Actividades das famílias empregadoras de pessoal doméstico
        </option>
        <option value="98100">
          98100 - Actividades de produção de bens pelas famílias para uso
          próprio
        </option>
        <option value="98200">
          98200 - Actividades de produção de serviços pelas famílias para uso
          próprio
        </option>
        <option value="99000">
          99000 - Actividades dos organismos internacionais e outras
          instituições extra-territoriais
        </option>
      </React.Fragment>
    );
  }
}

export default DropdownCAE;
